module.exports = __webpack_public_path__ + "img/NoPhoto.a34fddf5.svg";